import { cn } from "@/lib/utils";
import { Alert, AlertDescription, AlertTitle } from "@ndd/ui";

interface SectionErrorFallbackProps {
  sectionName: string;
  className?: string;
}

export function SectionErrorFallback({
  sectionName,
  className,
}: SectionErrorFallbackProps) {
  const displayName = sectionName.replace(/_/g, " ");
  return (
    <Alert variant="danger" className={cn("rounded-xl", className)}>
      <AlertTitle>Unable to load {displayName}</AlertTitle>
      <AlertDescription>
        This section could not be generated for this analysis. Other sections are
        unaffected.
      </AlertDescription>
    </Alert>
  );
}
